import React from 'react'
import { Prompt } from "react-router-dom";
class IEprompt extends React.Component{
    render(){
        return <Prompt
        when={!!this.props.changes}
        message={location => `You have not saved form data. Do you want to proceed?`}
      />
    }
}
export default IEprompt